var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"outlined":"","color":"#1D6F42","loading":_vm.isLoading},on:{"click":_vm.onClick}},'v-btn',_vm.size,false),[_c('v-icon',{attrs:{"color":"#1D6F42"}},[_vm._v("mdi-file-excel")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }